const GlobalAlerts = require('../functions/GlobalAlerts');
const Lang = require('lang');

function confirmIsExists() {
  const body = nifty.body;
  const sendFormBtn = document.querySelector('#btn-confirmation');
  const modalOpened = $('#' + sendFormBtn.dataset.modal);
  const form = document.querySelector('#formValidation');
  const url = sendFormBtn.dataset.url;
  const idEmpresa = sendFormBtn.dataset.idcentrocusto !== undefined
    ? sendFormBtn.dataset.idcentrocusto
    : null;

  // adiciona evento ao botão
  sendFormBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const nome = document.querySelector('#nome').value;

    // Verificar se o campo nome foi preenchido antes de continuar
    if (!nome) {
      showMessage(Lang.get('js/src/functions/confirmIfExists.name_required'), 'danger');
    } else {
      // chama a função que envia no nome da empresa para ver se ja existe
      sendRequest(url, nome, idEmpresa)
        .done(function (data) {
          if (data.data === null) {
            form.submit();
          } else {
            modalAviso(form, body, modalOpened, data.message);
          }
        })
        .fail(function (error) {
          // chama função que exibe mensagem de erro
          showMessage(error.responseJSON.message, 'danger');
        });
    }
  });
}

// Exibe o modal com mensagem de aviso
function modalAviso(form, body, modalOpened, message) {
  modalOpened.modal('hide');
  const modal = bootbox.dialog({
    title: Lang.get('js/src/functions/confirmIfExists.confirmation'),
    message: message,
    buttons: {
      cancel: {
        label: Lang.get('js/src/functions/confirmIfExists.cancel'),
        className: 'btn-default',
        callback: function () {
          modalOpened.modal('show');
        }
      },
      confirm: {
        label: Lang.get('js/src/functions/confirmIfExists.confirm'),
        className: 'btn-success',
        callback: function () {
          form.submit();
        }
      }
    }
  })
}

// requisição para a verificação se existe empresa com o mesmo nome
function sendRequest(url, nome, id = null) {
  return $.ajax({
    method: 'POST',
    url: url,
    data: {
      'nome': nome,
      'id': id
    },
  });
}

// Exibe a mensagem de erro ou sucesso
function showMessage(message, type) {
  GlobalAlerts.createAndShow({
    type: type,
    title: '',
    message: message
  });
}

module.exports = {
  init: confirmIsExists,
  url: /^\/settings\/centros-de-custos|^\/settings\/projetos/,
};
